import React from 'react';
import { Button, DatePicker, Form, Input, Modal, Tag } from 'antd';
import moment, { Moment } from 'moment';
import { ProductSelectItem } from './product-select-modal';

const { TextArea } = Input;

type DimType = 'SPU' | 'SKU';

export type ScheduleCreateFormErrors = {
    name: string;
    code: string;
    shelfTime: string;
    unshelfTime: string;
    remark: string;
};

type ScheduleCreateModalProps = {
    dim: DimType;
    visible: boolean;
    name: string;
    selectedItems: ProductSelectItem[];
    shelfTime: Moment | null;
    unshelfTime: Moment | null;
    remark: string;
    errors: ScheduleCreateFormErrors;
    confirmLoading?: boolean;
    onCancel: () => void;
    onOk: () => void;
    onOpenSelect: () => void;
    onRemoveSelected: (code: string) => void;
    onNameChange: (value: string) => void;
    onShelfTimeChange: (value: Moment | null) => void;
    onUnshelfTimeChange: (value: Moment | null) => void;
    onRemarkChange: (value: string) => void;
};

export const ScheduleCreateModal = ({
    dim,
    visible,
    name,
    selectedItems,
    shelfTime,
    unshelfTime,
    remark,
    errors,
    confirmLoading,
    onCancel,
    onOk,
    onOpenSelect,
    onRemoveSelected,
    onNameChange,
    onShelfTimeChange,
    onUnshelfTimeChange,
    onRemarkChange,
}: ScheduleCreateModalProps) => {
    return (
        <Modal
            title="创建定时任务"
            visible={visible}
            onCancel={onCancel}
            onOk={onOk}
            confirmLoading={confirmLoading}
            destroyOnClose
            width={640}
            wrapClassName="shelf-rule-add-modal"
            okText="确定"
            cancelText="取消"
        >
            <Form layout="horizontal" labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
                <Form.Item
                    label="定时任务名称"
                    required
                    validateStatus={errors.name ? 'error' : ''}
                    help={errors.name || undefined}
                >
                    <div className="shelf-rule__remark">
                        <Input
                            placeholder="请填写定时任务名称"
                            value={name}
                            maxLength={100}
                            onChange={(e) => onNameChange(e.target.value.slice(0, 100))}
                        />
                        <div className="shelf-rule__remark-count">{name.length} / 100</div>
                    </div>
                </Form.Item>
                <Form.Item
                    label={`${dim}编码`}
                    required
                    validateStatus={errors.code ? 'error' : ''}
                    help={errors.code || undefined}
                >
                    <Button onClick={onOpenSelect}>选择 {dim}</Button>
                    {selectedItems.length > 0 ? (
                        <div className="shelf-rule__selected-tags">
                            {selectedItems.map((item) => (
                                <Tag
                                    key={item.code}
                                    closable
                                    onClose={() => onRemoveSelected(item.code)}
                                >
                                    {item.code}
                                </Tag>
                            ))}
                        </div>
                    ) : (
                        !errors.code && (
                            <div className="shelf-rule__select-hint">请选择一个或多个 {dim}</div>
                        )
                    )}
                </Form.Item>
                <Form.Item
                    label="上架时间"
                    validateStatus={errors.shelfTime ? 'error' : ''}
                    help={errors.shelfTime || undefined}
                >
                    <DatePicker
                        showTime={{ format: 'HH:mm' }}
                        format="YYYY-MM-DD HH:mm"
                        placeholder="选填"
                        style={{ width: '100%' }}
                        value={shelfTime}
                        onChange={onShelfTimeChange}
                        disabledDate={(current) => !!current && current < moment().startOf('day')}
                    />
                </Form.Item>
                <Form.Item
                    label="下架时间"
                    validateStatus={errors.unshelfTime ? 'error' : ''}
                    help={errors.unshelfTime || undefined}
                >
                    <DatePicker
                        showTime={{ format: 'HH:mm' }}
                        format="YYYY-MM-DD HH:mm"
                        placeholder="选填"
                        style={{ width: '100%' }}
                        value={unshelfTime}
                        onChange={onUnshelfTimeChange}
                        disabledDate={(current) => !!current && current < moment().startOf('day')}
                    />
                </Form.Item>
                <Form.Item
                    label="说明"
                    validateStatus={errors.remark ? 'error' : ''}
                    help={errors.remark || undefined}
                >
                    <div className="shelf-rule__remark">
                        <TextArea
                            rows={4}
                            maxLength={200}
                            placeholder="选填"
                            value={remark}
                            onChange={(e) => onRemarkChange(e.target.value.slice(0, 200))}
                        />
                        <div className="shelf-rule__remark-count">{remark.length} / 200</div>
                    </div>
                </Form.Item>
            </Form>
            <div className="shelf-rule__schedule-create-tip">
                上架时间与下架时间至少填一端。创建后，商品会写入禁止上架名单（来源：活动定时）。
            </div>
        </Modal>
    );
};
